module.exports = __webpack_public_path__ + "img/contacto-icono-email.668a4816.svg";